"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStore = void 0;
const browser_monads_1 = require("browser-monads");
const redux_1 = require("redux");
const redux_thunk_1 = __importDefault(require("redux-thunk"));
const reducer_1 = require("./reducer");
const state_1 = require("./state");
const createStore = (state) => {
    const initialState = (0, state_1.createInitialState)(state);
    // This is to configure the redux devtools plugin and there really isn't a good way to type it, and it's not worth it.
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const composeEnhancers = browser_monads_1.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
    return (0, redux_1.createStore)(
    // testing this would be tough and just testing the internals of react-redux
    // istanbul ignore next
    (x = initialState, y) => (0, reducer_1.reducer)(x, y), initialState, composeEnhancers((0, redux_1.applyMiddleware)(redux_thunk_1.default)));
};
exports.createStore = createStore;
//# sourceMappingURL=store.js.map